function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable linebreak-style */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var ProgressBar = /*#__PURE__*/function (_Component) {
  function ProgressBar(props) {
    var _this;
    _classCallCheck(this, ProgressBar);
    _this = _callSuper(this, ProgressBar, [props]);
    _this.defaultDictionary = {
      HearingTest: {
        ButtonResponse: 'Questions',
        Calibration: 'Calibration',
        Tone: 'Sound test'
      }
    };
    _this.state = {
      dictionary: _this.defaultDictionary
    };
    return _this;
  }
  _inherits(ProgressBar, _Component);
  return _createClass(ProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var theLang = $('html').attr('lang');
      var dict = this.defaultDictionary;
      DGS.Dictionary.getInstance().getTexts(dict, function () {
        _this2.setState(_objectSpread(_objectSpread({}, _this2.state), {}, {
          dictionary: dict
        }));
      }, theLang);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var items = [];
      var margin = 3;
      var sections = [{
        name: 'ButtonResponse',
        indexes: []
      }, {
        name: 'Calibration',
        indexes: []
      }, {
        name: 'Tone',
        indexes: []
      }];
      var envSteps = this.props.steps.filter(function (step) {
        return step !== undefined;
      });
      envSteps.forEach(function (step, index) {
        if (step.StepViewType === 'ButtonResponse') {
          var section = sections.find(function (item) {
            return item.name === 'ButtonResponse';
          });
          section.indexes.push(index + 1);
        }
        if (step.StepViewType.includes('Calibration')) {
          var _section = sections.find(function (item) {
            return item.name.includes('Calibration');
          });
          _section.indexes.push(index + 1);
        }
        if (step.StepViewType === 'Tone') {
          var _section2 = sections.find(function (item) {
            return item.name === 'Tone';
          });
          _section2.indexes.push(index + 1);
        }
      });
      var sectionsLength = sections.length;
      var percentWidth = 100 / sectionsLength;
      var currentSectionStep = sections.findIndex(function (section) {
        return section.indexes.includes(_this3.props.currentStep);
      }) + 1;
      for (var i = 1; i <= sectionsLength; i += 1) {
        var isDone = i <= currentSectionStep;
        var isCurrent = i === currentSectionStep;
        items.push(/*#__PURE__*/React.createElement("div", {
          className: "progress-bar__block\n        ".concat(isDone ? 'progress-bar__block--active' : '', "\n        ").concat(isCurrent ? 'progress-bar__block--current' : '', "\n        "),
          key: i,
          style: {
            width: "calc(".concat(percentWidth, "% - ").concat(margin, "px)")
          }
        }));
      }
      var ballonXPos = percentWidth * currentSectionStep - percentWidth / 2;
      return /*#__PURE__*/React.createElement("div", {
        className: "progress-bar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "progress-bar__blocks"
      }, items), /*#__PURE__*/React.createElement("div", {
        className: "progress-bar__balloon",
        style: {
          left: "".concat(ballonXPos, "%")
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "progress-bar__text"
      }, this.state.dictionary.HearingTest[sections[currentSectionStep - 1].name])));
    }
  }]);
}(Component);
ProgressBar.propTypes = {
  steps: PropTypes.any.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
};
export default ProgressBar;